//
// Copyright (c) 2024 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import SnippetEditing from "./snippetEditing";
import SnippetUi from "./snippetUi";
import SnippetToolbar from "./snippetToolbar";

export default class Snippet extends Plugin {
  static get requires() {
    return [SnippetEditing, SnippetToolbar, SnippetUi];
  }

  static get pluginName() {
    return "Snippet";
  }
}
